import { assetLoader, audioPlayer, flump } from "../PhaserExtension";
import * as States from "./States";
import * as GameModel from "../models/GameModel";
import BaseState from "./BaseState";
import FlumpObject from "../general/objects/FlumpObject";

export default class RecapState extends BaseState
{
    preload()
    {
        assetLoader.preloadAssetPacks(this.game, ["recap"]);
        super.preload();

        for(let i = 0; i < GameModel.data.drawHistory.length; i++)
        {
            this.game.load.image("image" + i, GameModel.data.drawHistory[i].colored);
            assetLoader.loadLocalizedAudio(this.game, "storyVO" + i, GameModel.data.drawHistory[i].playerVO);
        }
    }

    create()
    {
        this.config = this.game.cache.getJSON("recapConfig");
        flump.addLibrary(this.game, "coloringFlump", "assets/coloring/flump/");
        audioPlayer.setupChannels(this.config.sounds.channels);

        this.voIndex = 0;

        this.hands = new FlumpObject(this.game, this.config.assets.hands, "coloringFlump");
        this.backgroundLayer.add(this.hands);

        this.comicConf = this.config.assets.comic;
        this.comic = this.game.add.image(this.game.width / 2, 70, "image0", undefined, this.maingroundLayer);
        this.comic.anchor.setTo(0.5, 0);

        this.subtitles = new Phaser.Text(this.game, this.game.width / 2, this.game.height / 2 + 187, GameModel.data.drawHistory[this.voIndex].storyText[+GameModel.data.english],
            {font:"SesameWorkshop", fontSize:22, fill:"black", align: "left", wordWrap: true, wordWrapWidth: 625, boundsAlignV: 'middle'});
        this.subtitles.anchor.setTo(0.5, 0);
        this.subtitles.textBounds = new Phaser.Rectangle(0, 0, 725, 135);
        let numLines = this.subtitles.precalculateWordWrap(GameModel.data.drawHistory[this.voIndex].storyText[+GameModel.data.english]).length;
        this.subtitles.lineSpacing = -3 - numLines;
        this.subtitles.fontSize = 31 - numLines * 2;
        this.foregroundLayer.add(this.subtitles);

        GameModel.data.currentStateName = "Story recap screen";
        super.create();
    }

    onTransitionInComplete()
    {
        super.onTransitionInComplete();
        //audioPlayer.play(this.game, this.config.sounds.intro1, this.onIntroVOComplete, this);
        audioPlayer.play(this.game, this.config.sounds.intro2, this.playNextVO, this);
        audioPlayer.play(this.game, this.config.sounds[GameModel.data.storyKey]);
    }

    onIntroVOComplete()
    {
        audioPlayer.play(this.game, this.config.sounds.intro2, this.playNextVO, this);
    }

    playNextVO()
    {
        audioPlayer.play(this.game, this.config.sounds.storyVO[this.voIndex], this.onStoryVOComplete, this);
    }

    onStoryVOComplete()
    {
        this.voIndex += 1;

        if(this.voIndex >= GameModel.data.drawHistory.length)
        {
            audioPlayer.play(this.game, this.config.sounds.end, this.transistionOut, this);
        }
        else
        {
            this.game.add.tween(this.comic).to({y: this.comic.y + this.game.height * 1.5}, this.comicConf.tweenTime, Phaser.Easing.Quadratic.InOut, true)
                         .onComplete.addOnce(this.onComicOut, this);
            this.game.add.tween(this.hands).to({y: this.hands.y + this.game.height * 1.5}, this.comicConf.tweenTime, Phaser.Easing.Quadratic.InOut, true);
            this.game.add.tween(this.subtitles).to({y: this.subtitles.y + this.game.height * 1.5}, this.comicConf.tweenTime, Phaser.Easing.Quadratic.InOut, true);
        }
    }

    onComicOut()
    {
        this.comic.loadTexture("image" + this.voIndex);
        this.game.add.tween(this.comic).to({y: this.comic.y - this.game.height * 1.5}, this.comicConf.tweenTime, Phaser.Easing.Quadratic.InOut, true)
                     .onComplete.addOnce(this.onComicIn, this);
        this.game.add.tween(this.hands).to({y: this.hands.y - this.game.height * 1.5}, this.comicConf.tweenTime, Phaser.Easing.Quadratic.InOut, true);

        this.subtitles.text = GameModel.data.drawHistory[this.voIndex].storyText[+GameModel.data.english];
        this.subtitles.fontSize = 22;
        this.subtitles.lineSpacing = 0;
        let numLines = this.subtitles.precalculateWordWrap(GameModel.data.drawHistory[this.voIndex].storyText[+GameModel.data.english]).length;
        this.subtitles.lineSpacing = -3 - numLines;
        this.subtitles.fontSize = 31 - numLines * 2;

        this.game.add.tween(this.subtitles).to({y: this.subtitles.y - this.game.height * 1.5}, this.comicConf.tweenTime, Phaser.Easing.Quadratic.InOut, true);
    }

    onComicIn()
    {
        this.playNextVO();
    }

    onTransitionOutComplete()
    {
        this.game.state.start(States.POSTGAME);
    }

    shutdown()
    {
        for(let i = 0; i < GameModel.data.drawHistory.length; i++)
        {
            this.game.cache.removeImage("image" + i, true);
            this.game.cache.removeSound("storyVO" + i);
        }

        assetLoader.unloadAssetPacks(this.game, ["recap"]);
        audioPlayer.stopChannel("SFX");
        audioPlayer.cleanupChannels(this.config.sounds.channels);
        flump.removeLibrary("coloringFlump");
        delete this.comicConf;
        delete this.subtitles;
        delete this.hands;
        delete this.config;
        super.shutdown();
    }
}
